import React from 'react';
import { useSelector } from 'react-redux';
import { Icons, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import {
  dateFormatter, infoFormatterIntl, localeFormatter,
} from '../../../../utils/formatters';
import { getDriverData } from '../../reducer';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';
import FileView from '../../../../components/fields/FileInput/FileView';

export function DriverBox(props) {
  const {
    onClose = () => {},
  } = props;
  const {
    formatMessage,
  } = intlShape;

  const {
    loadingDriverCard,
    driverCard = {
    },
  } = useSelector(getDriverData);

  const fieldsValidation = null;

  const driver_criminal_record_scan = driverCard?.files ? driverCard?.files?.filter(item => item.collection_name === 'driver_criminal_record_scan') : undefined;
  const driver_photo_with_identity = driverCard?.files ? driverCard?.files?.filter(item => item.collection_name === 'driver_photo_with_identity') : undefined;
  const driver_license_scan = driverCard?.files ? driverCard?.files?.filter(item => item.collection_name === 'driver_license_scan') : undefined;

  return (
    <div className="dlc-body">
      <TimerLoader loading={loadingDriverCard} />
      <div className="dlc-main">
        <div className="dlc-main-title">
          <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
          <div className="f3">{formatMessage({ id: 'driver.card.menu.driver' })}</div>
        </div>
        <Row className="row-cols-3">
          {infoFormatterIntl('citizenship', localeFormatter('citizenship.type', driverCard?.driver_citizenship), fieldsValidation, 'citizenship')}
        </Row>
        <Row className="row-cols-3">
          {infoFormatterIntl('last_name', driverCard?.driver_last_name, fieldsValidation, 'last_name')}
          {infoFormatterIntl('first_name', driverCard?.driver_first_name, fieldsValidation, 'first_name')}
          {infoFormatterIntl('middle_name', driverCard?.driver_middle_name, fieldsValidation, 'middle_name')}
        </Row>
        <Row className="row-cols-3">
          {infoFormatterIntl('phone', driverCard?.driver_phone, fieldsValidation, 'phone')}
          {infoFormatterIntl('email', driverCard?.driver_email, fieldsValidation, 'email')}
          {infoFormatterIntl('birth_date', dateFormatter(driverCard?.driver_birth_date), fieldsValidation, 'birth_date')}
        </Row>
        <Row className="row-cols-3">
          {infoFormatterIntl('inn', driverCard?.driver_inn, fieldsValidation, 'inn')}
          {infoFormatterIntl('driver.external_id', driverCard?.driver_external_id, fieldsValidation, 'external_id')}
        </Row>
        <div className="hr-row mt-2" />
        <div className="f4 mt-2">Документ, удостоверяюший личность водителя</div>
        <Row className="row-cols-3">
          {infoFormatterIntl('identity_series', driverCard?.driver_identity_series, fieldsValidation, 'identity_series')}
          {infoFormatterIntl('identity_number', driverCard?.driver_identity_number, fieldsValidation, 'identity_number')}
          {infoFormatterIntl('identity_issue_date', dateFormatter(driverCard?.identity_issue_date), fieldsValidation, 'identity_issue_date')}
        </Row>
        <Row className="row-cols-3">
          {infoFormatterIntl('identity_issuer_code', driverCard?.driver_identity_issuer_code, fieldsValidation, 'identity_issuer_code')}
          {infoFormatterIntl('place_of_birth', driverCard?.driver_birth_place, fieldsValidation, 'place_of_birth')}
          {infoFormatterIntl('identity_issuer', driverCard?.driver_identity_issuer, fieldsValidation, 'identity_issuer')}
        </Row>
        <Row className="row-cols-3">
          {infoFormatterIntl('identity_type', localeFormatter('identity.type', driverCard?.driver_identity_type), fieldsValidation, 'identity_type')}
          {infoFormatterIntl('permanent_registration_address', driverCard?.driver_permanent_registration_address, fieldsValidation, 'permanent_registration_address')}
          {infoFormatterIntl('residential_address', driverCard?.driver_residential_address, fieldsValidation, 'residential_address')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('driver_photo_with_identity', driver_photo_with_identity ? <FileView readOnly withoutMime withoutHr files={driver_photo_with_identity} /> : null, fieldsValidation, 'driver_photo_with_identity')}
        </Row>
        <div className="hr-row mt-2" />
        <div className="f4 mt-2">Водительское удостоверение</div>
        <Row className="row-cols-2">
          {infoFormatterIntl('driver_license_series', driverCard?.driver_license_series, fieldsValidation, 'driver_license_series')}
          {infoFormatterIntl('driver_license_number', driverCard?.driver_license_number, fieldsValidation, 'driver_license_number')}
        </Row>
        <Row className="row-cols-3">
          {infoFormatterIntl('driver_license_issuer', driverCard?.driver_license_issuer, fieldsValidation, 'driver_license_issuer')}
          {infoFormatterIntl('driver_license_issuer_country', driverCard?.driver_license_issuer_country, fieldsValidation, 'driver_license_issuer_country')}
          {infoFormatterIntl('driver_license_experience', driverCard?.driver_license_experience, fieldsValidation, 'driver_license_experience')}
        </Row>
        <Row className="row-cols-3">
          {infoFormatterIntl('driver_license_valid_from_date', dateFormatter(driverCard?.driver_license_valid_from_date), fieldsValidation, 'driver_license_valid_from_date')}
          {infoFormatterIntl('expiration_date', dateFormatter(driverCard?.driver_license_valid_until_date), fieldsValidation, 'driver_license_valid_until_date')}
          {infoFormatterIntl('driver_license_issue_date', dateFormatter(driverCard?.driver_license_issue_date), fieldsValidation, 'driver_license_issue_date')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('media.driver_license_files', driver_license_scan ? <FileView readOnly withoutMime withoutHr files={driver_license_scan} /> : null, fieldsValidation, 'driver_license_scan')}
        </Row>
      </div>
      <div className="dlc-additional">
        <div className="f4 ">Трудовой договор</div>
        <Row className="row-cols-3">
          {infoFormatterIntl('employment_contract_date', dateFormatter(driverCard?.driver_employment_contract_date), fieldsValidation, 'employment_contract_date')}
          {infoFormatterIntl('employment_contract_number', driverCard?.driver_employment_contract_number, fieldsValidation, 'employment_contract_number')}
        </Row>
        <div className="hr-row mt-2" />
        <div className="f4 mt-2">Справка о наличии (отсутствии) судимости и (или) факта уголовного преследования либо о прекращении уголовного преследования</div>
        <div className="mb-2" />
        <Row className="row-cols-3">
          {infoFormatterIntl('criminal_record_series', driverCard?.driver_criminal_record_series, fieldsValidation, 'criminal_record_series')}
          {infoFormatterIntl('criminal_record_number', driverCard?.driver_criminal_record_number, fieldsValidation, 'criminal_record_number')}
          {infoFormatterIntl('criminal_record_issue_date', dateFormatter(driverCard?.driver_criminal_record_issue_date), fieldsValidation, 'criminal_record_issue_date')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('criminal_record_scan', driver_criminal_record_scan ? <FileView readOnly withoutMime withoutHr files={driver_criminal_record_scan} /> : null, fieldsValidation, 'driver_criminal_record_scan')}
        </Row>
        <div className="mb-2" />
      </div>
    </div>
  );
}
